angular
  .module("customerOfAgentSearch.components", [])
  .component("customerOfAgentSearch", {
    templateUrl: "ng/components/customerOfAgentSearch/customerOfAgentSearch.view.html",
    controllerAs: "customerOfAgentSearchCtrl",
    bindings: {
      configObj: "="
    },
    controller: function (
      $scope,
      $rootScope,
      $searchUserService,
      $portalService,
      $userService,
      $featureService,
      $configService,
      $agentService,
      FactoryObj
    ) {
      console.log(
        "customerOfAgentSearch.components - $rootScope.portalName=" +
        $rootScope.portalName
      );
      if ($rootScope.portalName == "ILEAF_ARF") {
        $scope.isARF = true;
      } else {
        $scope.isARF = false;
      }

      $scope.ArfSelectUserMonitoring = $featureService.ArfSelectUserMonitoring();
      //$scope.ArfSelectUserMonitoring = false;

      /** this refererence depends from context */
      var self = this;

      self.$onInit = function () {
        $scope.AralSimulationRi = $featureService.AralSimulationRi();
        $scope.ArfPrintContractDetail = $featureService.ArfPrintContractDetail();
        self.loading = false;
        self.searchUserService = $searchUserService;
        self.customerList = [];
        self.searchUserObj = {};
        self.configObj.selectedAppVendor = {};
      };
      /* self.configObj.selectedAppCustomerUser = {
         ndg: null
       }; */


      self.agentService = $agentService;
      self.showVendorSelect = false;
      //** If in arf, do not show the vendor select */
      if ($configService.getUser().type == "VENDOR_AGENT") {
        self.showVendorSelect = true;
      } else {

        self.configObj.selectedAppVendorUserUser = {
          //  ndg: $configService.getUser().identifier
          ndg: self.customerList.identifier
        };
        FactoryObj.selectedAppVendorUser = self.configObj.selectedAppCustomerUser;
      }


      $scope.changeUser = function () {
        console.log("CHANGE USER- ID=" + $scope.actualUser);
        self.selectedVendor = {
          identifier: $scope.actualUser
        };
        self.fetchAndRedrawCharts();
      };

      $scope.getAllChild = function () {
        $userService.getFullChildren().then(function (userList) {
          for (i = 0; i < userList.length; i++) {
            $scope.users.push(
              new user(
                userList[i].name + " " + userList[i].surname,
                userList[i].identifier
              )
            );
          }
        });
      };

      function user(name, id) {
        var self = this;
        self.totalName = name;
        self.identifier = id;
      }
      $scope.users = [];

      $scope.actualUser = $configService.getUser().identifier;
      $scope.parentUser = {
        name: $configService.getUser().name,
        identifier: $configService.getUser().identifier,
        type: $configService.getUser().type
      };
      $scope.getAllChild();

      var pieChart = null;
      var barChart = null;
      var doughnutChart = null;

      self.vendorList = [];

      //hook on the carousel slide
      $(".carousel").on("slide.bs.carousel", function () {
        //console.log('slide slided!');
      });

      self.activeChart = 0;

      self.initialize = function () {
        //if we are in ara
        if (self.showVendorSelect) {
          self.loaderChoseVendor = true;
          //fetch vendors, fetch charts data and draw them
          // $agentService.getVendorsOfAgent().then(function(res) {

          $agentService.getVendorsOfAgent($scope.actualUser)
            .then(function (res) {
              self.customerList = res && res.listAppUser;
              self.loaderChoseVendor = false;

            })
            .catch(function (error) {
              console.log(error);
              self.loaderChoseVendor = false;
            });
        }

      };



      //init component
      self.initialize();
      self.setSelectedAppVendorUser = function (customer) {
        console.log("FOUND CUSTOMER - ", customer);
        /** prendo tutti gli elementi selezionati */
        /*   if (self.isFromAra) {
               self.configObj.selectedAppCustomerUser = customerList;
           } else { */
        /**selezione automatica del primo */
        if (!customer.selected) {
          for (var i = 0; i < self.customerList.length; i++) {
            self.customerList[i].selected = false;
          }
          customer.selected = true;
          self.configObj.selectedAppCustomerUser = customer;

          if (self.configObj.searchResultWithoutNewUser) {
            console.log("self.configObj.searchResultWithoutNewUser is TRUE - selectedAppVendorUser");
            FactoryObj.selectedAppVendorUser = customer;
          } else {
            console.log("self.configObj.searchResultWithoutNewUser is FALSE - selectedAppCustomerUser");
            FactoryObj.selectedAppCustomerUser = customer;
          }

        } else {
          return;
          //customer.selected = false;
          //self.configObj.selectedAppCustomerUser = null;
        }
        //    }
      }


    }
  });